import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { withErrorBoundary } from '../../../hocs/withErrorBoundary';
import { selectComplaintReasons } from '../../../redux/data/selectors';

import styles from './index.styl';

const mapStateToProps = state => ({
  reportReasons: selectComplaintReasons(state),
});

const mapDispatchToProps = {};

export const enhance = compose(
  withErrorBoundary,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Ui/Report/enhance.js